<template>
  <section class="mt-3 mb-3">
    <b-card
      title="Catégorie parente actuelle"
      class="mb-3"
      v-if="categoryMirakl.hierarchyParentCode"
    >
      <b-card-body>
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton-table
              :rows="5"
              :columns="3"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </template>
          <ul>
            <li>
              Nom catégorie :
              {{ categoryMirakl.hierarchyParentCode.hierarchyCode }}
            </li>
            <li>
              Code catégorie :
              {{ categoryMirakl.hierarchyParentCode.hierarchyLabel }}
            </li>
          </ul>
        </b-skeleton-wrapper>
      </b-card-body>
    </b-card>

    <b-card title="Modifier la catégorie parente" class="mb-3">
      <b-card-body>
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton-table
              :rows="5"
              :columns="3"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </template>

          <template v-if="hierarchyParent">
            <div class="d-inline-flex align-items-center">
              <span
                >Parent sélectionné :
                {{ hierarchyParent["hierarchyLabel"] }}</span
              >
              <button
                type="button"
                class="close ml-1"
                aria-label="Close"
                @click="hierarchyParent = null"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <gwz-button
              class="float-right"
              submitButtonText="Valider"
              @click="submit({ hierarchyParentCode: hierarchyParent['@id'] })"
            />
          </template>
          <template v-else>
            <gwzAutoComplete
              input-label="Chercher un nouveau parent"
              ref="initParent"
              :http="httpMirakl"
              labelName="hierarchyLabel"
              queryParamName="hierarchyLabel"
              nameEndpoint="listMirakl"
              placeholder="Rechercher une catégorie MIRAKL"
              @response="pickParent"
              aria-describedby="mirakl-category-input-parent-feedback"
            ></gwzAutoComplete>
          </template> </b-skeleton-wrapper></b-card-body
    ></b-card>

    <b-card title="Modifier le label">
      <b-card-body>
        <b-skeleton-wrapper :loading="isLoading">
          <template #loading>
            <b-skeleton-table
              :rows="5"
              :columns="3"
              :table-props="{ bordered: true, striped: true }"
            ></b-skeleton-table>
          </template>

          <b-form-group
            label-cols="7"
            label-cols-lg="5"
            label-size="small"
            label="Nouveau label"
            label-for="input-category-label"
          >
            <b-form-input
              id="input-category-label"
              placeholder="Label catégorie MIRAKL"
              v-model="hierarchyLabel"
              aria-describedby="categories-mirakl-feedback"
              required
            ></b-form-input>
          </b-form-group>
          <div class="text-right">
            <gwz-button
              v-if="hierarchyLabel != ''"
              submitButtonText="Valider"
              @click="submit({ hierarchyLabel })"
            />
          </div>
        </b-skeleton-wrapper>
      </b-card-body>
    </b-card>
  </section>
</template>

<script>
import GwzButton from "@/components/gwzButton";
import gwzAutoComplete from "@/components/gwzAutoComplete";
import { mapGetters } from "vuex";

export default {
  name: "ModifierMapping",
  props: {
    categoryMirakl: {
      type: Object,
      required: true
    }
  },
  components: {
    GwzButton,
    gwzAutoComplete
  },
  data() {
    return {
      httpMirakl: this.$gwzApi.service("categories"),
      hierarchyLabel: "",
      hierarchyParent: null
    };
  },
  computed: {
    ...mapGetters(["isLoading"])
  },
  methods: {
    pickParent(hierarchyParent) {
      this.hierarchyParent = hierarchyParent;
    },
    submit(params) {
      this.$store
        .dispatch("categories/editMiraklCategory", {
          params,
          id: this.categoryMirakl.id
        })
        .then(() => {
          this.hierarchyLabel = "";
          this.hierarchyParent = null;
          this.$emit("reload");
        });
    }
  }
};
</script>

<style scoped></style>
